import { useState, useRef } from "react";
// --- lottie ----------------------------------------------------------------
import Lottie from "lottie-react";
import contactLogo from "../../assets/lotties/logo-purple.json";
// --- media ----------------------------------------------------------------
import videoSound from "../../assets/videos/make-soundproduction.mp4";
import videoVideo from "../../assets/videos/make-videoproduction.mp4";
import videoMusic from "../../assets/videos/make-musicvideo.mp4";
import videoAd from "../../assets/videos/make-adverticement.mp4";
import videoDrama from "../../assets/videos/make-webdrama.mp4";
import videoBrand from "../../assets/videos/make-brandedcreative.mp4";
import {
  serviceMakeCreate01,
  serviceMakeCreate02,
  serviceMakeCreate03,
  serviceMakeCreate04,
  serviceMakeCreate05,
  serviceMakeCreate06,
  serviceMakeCreate07,
  serviceMakeCreate08,
  serviceMakeThumb01,
  serviceMakeThumb02,
  serviceMakeThumb03,
  serviceMakeThumb04,
  serviceMakeThumb05,
  serviceMakeThumb06,
  pauseIcon,
  playIcon,
  kakaoIcon,
} from "../../assets/images";

function Make() {
  // --- 데이터 ----------------------------------------------------------------
  const videoItems = [
    {
      id: "sound-production",
      label: "SOUND PRODUCTION",
      thumb: serviceMakeThumb01, // 동영상 썸네일
      videoSrc: videoSound, // 실제 영상 루트
      title: "SOUND PRODUCTION",
      subtitle: "사운드 제작",
      bullets: [
        "AI 또는 직접 작곡",
        "원곡/컨셉 기반 맞춤형 음악 제작",
        "장르별(POP, HIPHOP, R&B, OST 등) 세션 작곡 가능",
        "보컬 피처링 및 믹싱/마스터링 포함",
      ],
    },
    {
      id: "video-production",
      label: "VIDEO PRODUCTION",
      thumb: serviceMakeThumb02,
      videoSrc: videoVideo,
      title: "VIDEO PRODUCTION",
      subtitle: "영상 제작",
      bullets: [
        "AI 영상 또는 직접 촬영 (혼합형 가능)",
        "스토리보드 기획부터 촬영, 편집, 색보정까지",
        "인물, 제품, 공간 등 맞춤형 시각 콘셉트 구성",
        "4K 영상 + SNS 최적화 버전 (세로형)",
      ],
    },
    {
      id: "music-video",
      label: "MUSIC VIDEO",
      thumb: serviceMakeThumb03,
      videoSrc: videoMusic,
      title: "MUSIC VIDEO",
      subtitle: "뮤직비디오 제작",
      bullets: [
        "숏폼(15~60초) / 롱폼(1~3분) MV 제작",
        "실제 촬영 or AI 비주얼 기반 하이브리드형",
        "아티스트 퍼포먼스 중심 또는 스토리형 구성",
      ],
    },
    {
      id: "advertisement",
      label: "ADVERTISEMENT",
      thumb: serviceMakeThumb04,
      videoSrc: videoAd,
      title: "ADVERTISEMENT",
      subtitle: "광고 제작",
      bullets: [
        "브랜드 / 인플루언서 중심 광고 영상 제작",
        "실제 촬영 or AI 모델 활용 가능",
        "SNS / 유튜브 / OTT 등 노출 채널에 맞춘 편집",
        "WEB CONTENTS (웹 콘텐츠) / 드라마",
      ],
    },
    {
      id: "web-drama",
      label: "WEB DRAMA",
      thumb: serviceMakeThumb05,
      videoSrc: videoDrama,
      title: "WEB DRAMA",
      subtitle: "웹 드라마",
      bullets: [
        "AI 시나리오 or 실사 스토리텔링형 웹드라마 제작",
        "브랜드 협찬 · 음원 콜라보 연계형 콘텐츠",
        "OTT / 유튜브 연동 지원",
        "결과물 : 시리즈형 웹드라마 or 숏폼 시리즈 영상",
      ],
    },
    {
      id: "branded-creative",
      label: "BRANDED CREATIVE",
      thumb: serviceMakeThumb06,
      videoSrc: videoBrand,
      title: "BRANDED CREATIVE",
      subtitle: "종합 콘텐츠 제작",
      bullets: [
        "AI 음악 + AI 영상 융합형 콘텐츠",
        "브랜드 로고송 / AI 모델 인터뷰 / 프로모션 영상",
        "기업 · 아티스트 · 인플루언서 협업형 기획",
      ],
    },   
  ] 
  const createItems = [
    {id: 1, image: serviceMakeCreate01, title: "AI MUSIC"},
    {id: 2, image: serviceMakeCreate02, title: "CREATE VIDEO"},
    {id: 3, image: serviceMakeCreate03, title: "BRANDING FILM"},
    {id: 4, image: serviceMakeCreate04, title: "ARTIST MV"},
    {id: 5, image: serviceMakeCreate05, title: "MUSIC VISUAL"},
    {id: 6, image: serviceMakeCreate06, title: "AI PROMOTION"},
    {id: 7, image: serviceMakeCreate07, title: "AD&SHORTS"},
    {id: 8, image: serviceMakeCreate08, title: "CONTENT PACKAGE"}   
  ]

  // --- 비디오 ----------------------------------------------------------------
  const [activeId, setActiveId] = useState(videoItems[0]?.id);
  const activeItem = videoItems.find((v) => v.id === activeId) || videoItems[0];
  // 비디오 재생
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false); // 재생 여부
  const [isVideoOpen, setIsVideoOpen] = useState(false); // 썸네일 여부

  // --- 재생 버튼
  const handleTogglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };  

  // --- 동영상 제어
  const handleSelectVideo = (nextId) => {
    // 현재 재생 중인 영상 정지 및 상태 초기화
    setIsVideoOpen(false);
    setIsPlaying(false);

    const video = videoRef.current;
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    if (nextId === activeId) return;

    // 다른 썸네일 선택 시, 새로운 영상으로 변경
    setActiveId(nextId);
  };    

  
  return (
    <div className="content-section make">
      {/* === 동영상 갤러리 영역 === */}
      <section className="make__video-gallery max-12">
        <figure>
          <div className="video-box">
            {!isVideoOpen ? (
              <img src={activeItem.thumb} alt="" aria-hidden="true" className="video-thumb-img" />
            ) : (
            <video 
              ref={videoRef}
              src={activeItem.videoSrc}
              poster={activeItem.thumb}
              preload="metadata"
              playsInline
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => {
                setIsPlaying(false);
                setIsVideoOpen(false); // 종료 시 썸네일 복귀

                const v = videoRef.current;
                if (v) v.currentTime = 0;
              }}
            ></video>
            )}
            <button
              type="button"
              className="play-btn"
              aria-label={isPlaying ? "Pause video" : "Play video"}
              onClick={() => {
                if (!isVideoOpen) {
                  setIsVideoOpen(true);
                  requestAnimationFrame(() => {
                    handleTogglePlay(); // video 생긴 후 재생
                  });
                  return;
                }
                handleTogglePlay();
              }}
            >
              <img src={isPlaying ? pauseIcon : playIcon} alt="" aria-hidden="true" />
            </button>            

          </div>
          <figcaption>
            <h3>{activeItem.title}</h3>
            <p>{activeItem.subtitle}</p>

            <ul>
              {activeItem.bullets.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>            
          </figcaption>
        </figure>

        <div className="video-thumbs">
          <h4>
            동영상 더보기
          </h4>
          <ul>
            {videoItems.map((item) => (
            <li key={item.id}>
              <button
                className={`thumb ${item.id === activeId ? "active" : ""}`}
                onClick={() => handleSelectVideo(item.id)}
              >
                <img src={item.thumb} alt={item.title} />
                <span className="thumb-tit">{item.title}</span>
              </button>
            </li>
            ))}
          </ul>
        </div>      
      </section>

      {/* === PRODUCTION WORKFLOW */}
      <section className="make__flow">
        <div className="content-section__title dark">
          <span>아이디어부터 완성까지, 한 흐름으로 이어지는 제작 과정</span>
          <h3 className="gfont">PRODUCTION WORKFLOW</h3>
        </div>

        <ul className="flow-list">
          <li>
            <strong>STEP 01</strong>
            <p>상담 및 기획 고객 미팅<span className="text-arrow">→</span>콘셉트 · 장르 · 목표 설정</p>
          </li>
          <li>
            <strong>STEP 02</strong>
            <p>시안 제작, 음악 시안 또는 영상 콘티·스토리 보드 구성</p>
          </li>
          <li>
            <strong>STEP 03</strong>
            <p>제작 진행 촬영 · 편집 · 믹싱 · AI 생성 병행</p>
          </li>
          <li>
            <strong>STEP 04</strong>
            <p>검수 및 수정 클라이언트 피드백 반영 후 완성</p>
          </li>
          <li>
            <strong>STEP 05</strong>
            <p>납품 · 유통 · 홍보 완성본 전달 및 SNS 홍보 연동</p>
          </li>          
        </ul>        
      </section>  

      {/* === WHAT WE CREATE === */}
      <section className="make__create max-12">
        <div className="content-section__title">
          <span>음악을 더 쉽게, 창작을 더 자유롭게</span>
          <h3 className="gfont">WHAT WE CREATE</h3>
        </div>

        <ul className="create-list">
          {createItems.map((item) => (
            <li key={item.id} className="scale-wrap">
              <span
                className="scale-bg"
                style={{ backgroundImage: `url(${item.image})` }}
                aria-hidden="true"
              />
              <h4>
                <span>{item.title}</span>
              </h4>              
            </li>
          ))}
        </ul>       
      </section>  

      {/* === INQUIRY === */} 
      <div className="content-section__contact">
        <p className="desc">
          ALL MAKERS, ONE STAGE. 지금 당신의 무대를 시작하세요
        </p>
        <h3 className="gfont title">
          RESERVATION INQUIRY
        </h3>
        <Lottie
          animationData={contactLogo}
          loop
          autoplay
          className="contact-lottie"
        />

        <div className="kakao-link">
          <span>지금 시작해 보세요.</span>
          <a 
          href="https://pf.kakao.com/_QLTxgn"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={kakaoIcon} alt="" aria-hidden="true" />
            카카오 채널 문의
          </a>
        </div>
      </div>           
    </div>
  )
}

export default Make